<template>

   <div class="campaign-info border border-primary" v-if="campaign">

      <div class="campaign-info__flex">

         <div v-if="campaign.meeting_id">
            <strong>Meeting Title:</strong>
            {{campaign.name}}
         </div>

         <div v-if="campaign.meeting_id">
            <strong>Meeting ID:</strong>
            {{campaign.meeting_id}}
         </div>

         

         <div v-if="!campaign.meeting_id && campaign.poll_id">
            <strong>Poll Name:</strong>
            {{campaign.name}}

         </div>

         
         <div v-if="!campaign.meeting_id && !campaign.poll_id && campaign.calloutset_id">
            <strong>Campaign:</strong>
            {{campaign.name}}
         </div>

         
         <div v-if="campaign.poll_id">
            <strong>Poll ID:</strong>
            {{campaign.poll_id}}

         </div>

         
         <div v-if="campaign.calloutset_id">
            <strong>Callset ID:</strong>
            {{campaign.calloutset_id}}

         </div>

      </div>

   </div>

</template>

<script>
export default {
   props:{
      campaign: Object
   }
   
}
</script>

<style scoped>
   .campaign-info
   {
      padding: 0.3em;
      max-width: 63em;
      margin-left: auto;
      margin-right: auto;
      box-sizing: border-box;
      font-size: 0.8em;
   }

   .campaign-info__flex
   {
      display: flex;
      justify-content: center;
   }

   .campaign-info__flex > div
   {
      margin-right: 3em;
   }

   /**
   * Hide the number scroll arrows in number input fields.
   */
   input[type=number]
   {
      -moz-appearance: textfield;
   }

   input[type=number]::-webkit-outer-spin-button,
   input[type=number]::-webkit-inner-spin-button
   {
      -webkit-appearance: none;
      margin: 0;
   }

   /* Small only */
   /*@media screen and (max-width: 39.9375em) {}*/

   /* Medium and up */
   /*@media screen and (min-width: 40em) {}*/

   /* Medium only */
   /*@media screen and (min-width: 40em) and (max-width: 63.9375em) {}*/

   /* Large and up */
   /*@media screen and (min-width: 64em) {}*/

   /* Large only */
   /*@media screen and (min-width: 64em) and (max-width: 74.9375em) {}*/
</style>